import { appConstants } from "../../constants/appconstants";
import { postApiCall } from "../../utils/ApiMethods";

const FetchPowerSteeringKpiAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/power-steering/power-steering-kpi-page-details`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_POWERSTEERING_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    }
}

const FetchPowerSteeringMainAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/power-steering/power-steering-main-page-details`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_POWERSTEERING_CARD_ACTION' }, data);
        dispatch(resData);
    }
}

export { FetchPowerSteeringKpiAction, FetchPowerSteeringMainAction }